export enum AssigneeType {
  Escalationpolicy = 'escalationpolicy',
  Squad = 'squad',
  User = 'user',
  Team = 'team',
}
